<div class="modal__container">
  <div class="modal__content">
    <form [formGroup]="form">
      <ng-container *ngFor="let field of customFields">
        <p *ngIf="field.type === InputType.LABEL">{{field.label}}</p>
        <signaturit-input
          *ngIf="field.type === InputType.TEXT ||
            field.type === InputType.PASSWORD ||
            field.type === InputType.DATE"
          [inputType]="field.type"
          [labelName]="!field.customHTML ? field.label : null"
          [inputWidth]="260"
          [isRequired]="field.required"
          [innerHTMLLabel]="field.customHTML ? field.label : null"
          (outputValue)="setInputValue($event, field.key)">
        </signaturit-input>

        <signaturit-text-area
          *ngIf="field.type === InputType.PARAGRAPH"
          [labelName]="!field.customHTML ? field.label : null"
          [inputWidth]="260"
          [inputHeight]="60"
          [innerHTMLLabel]="field.customHTML ? field.label : null"
          (outputValue)="setInputValue($event, field.key)">
        </signaturit-text-area>

        <mat-checkbox
          *ngIf="field.type === InputType.CHECKBOX"
          class="modal__checkbox"
          (change)="setInputValue($event.checked, field.key)"
        >
          <p
            class="checkbox__label"
            *ngIf="!field.customHTML">
              {{ field.label + (field.required ? '*' : '') }}
          </p>
          <p
            class="checkbox__label"
            [innerHTML]="field.customHTML ? (field.label +  (field.required ? '*' : '')) : null">
          </p>
        </mat-checkbox>

      </ng-container>
    </form>
  </div>
  <div class="modal__actions">
    <signaturit-button
      [type]="'tertiary'"
      [size]="'md'"
      [text]="'cancel_text' | translate"
      (click)="closeModal()"
      >
    </signaturit-button>
    <signaturit-button
      [type]="'primary'"
      [size]="'md'"
      [text]="'confirm_text' | translate"
      [disabled]="!form.valid"
      (click)="onSubmit()">
    </signaturit-button>
  </div>
</div>
